<template>
    <pm-app-component hide-sidebar>

        <template slot="mobile-toolbar">
            <pm-application-bar simple>
               Advanced Settings
            </pm-application-bar>
        </template>

        <div style="padding: 14px 20px; font-weight: 600; text-transform: uppercase;">Videos</div>
        <div style="background: #fff; padding: 0 20px; box-shadow: 0 0 10px rgba(0,0,0,.1);">
            <pm-advanced-settings-item storage-key="video-legacy-format" title="Legacy video format" desc="For devices without support for modern video formats. Please note: videos in legacy format may take longer to start playing." />
            <pm-advanced-settings-item storage-key="video-disable-playsinline" title="Disable iOS inline play" desc="" />
            <pm-advanced-settings-item storage-key="video-disable-autoplay" title="Disable autoplay" desc="" />
            <pm-advanced-settings-item storage-key="video-force-update" title="Initial video forced update" desc="" />
        </div>
        <br/>
    </pm-app-component>
</template>

<style>

</style>

<script>
import ToolbarMixin from "@/extensions/mixins/mixin-toolbar";
import PmAdvancedSettingsItem from "./advanced-settings-item.vue";

export default {
    components: {
        PmAdvancedSettingsItem,
    },
    mixins: [
        ToolbarMixin,
    ],
    toolbar() {
        const items = [];



            items.push({ placeholder: true });

            items.push({ placeholder: true });

            items.push({ placeholder: true });

            items.push({
                back: true,
                callback: () => {
                    this.$router.push("/settings");
                },
            });


        return ([items]);
    },
    methods: {
        toolbarBack() {
            this.$router.push("/");
        },

    },
};
</script>
